@let sub = subscription();

<mat-expansion-panel style="flex: 1" class="active-panel" [expanded]="expanded()"
  [class.redirect-panel]="sub.order.redirectId !== null && sub.order.redirectId !== ''"
  [class.invalid-panel]="sub.isExpired || sub.isSuspended" [class.tbd-panel]="sub.order.TBD === true"
  (afterCollapse)="afterCollapse()" (afterExpand)="afterExpand()">
  <mat-expansion-panel-header>
    <div class="invalid-overlay"></div>
    <mat-panel-title>
      <mat-icon class="order-icon material-icon-filled" style="margin-right: 6px">{{ getLicenseTypeIcon() }}</mat-icon>
      <div class="header-title-container">
        <div class="header-title-info-container">
          <div class="header-title-info-container">
            <span class="info-highlighted">{{ "ACCESSCONFIG_NAME" | translate }}</span>
            <span>{{ sub.access.name }}</span>
          </div>
          <span class="info-highlighted">{{ "ACCESSCONFIG_ADMIN" | translate }} :</span>
          <span>{{ sub.access.admin.name }} - {{ sub.access.admin.eMail }}</span>
        </div>
        <div class="header-title-info-container">
          <span class="info-highlighted">{{ "ACCESSCONFIG_PLAN" | translate }}</span>
          <span>{{ "PLANID_" + sub.order.planId.toLocaleUpperCase() | translate }}</span>
        </div>
        <div class="header-title-info-container">
          <span class="info-highlighted">{{ "ACCESSCONFIG_EXPIREDATE" | translate }}</span>
          <span>{{ sub.order.expireDate }}</span>
        </div>

        @if (searchedText()) {
        <div class="header-title-info-container">
          <mat-icon [matTooltip]="sub.findsDescription">feature_search</mat-icon>
        </div>
        }
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div [ngClass]="compressed() ? 'order-body-compressed' : 'order-body'">
    <!-- ABBONAMENTO -->
    <mat-card appearance="outlined" class="card-container" style="flex-basis: 550px">
      <div class="title-container title-span" style="text-transform: uppercase">{{ "SUBSCRIPTION" | translate }}</div>
      <div class="card-content-vertical">
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_PLAN" | translate }}</span>
          <span>{{ "PLANID_" + sub.order.planId.toLocaleUpperCase() | translate }}</span>
        </div>
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_LICENSETYPE" | translate }}</span>
          <span>{{ getLicenseType(sub.order.licenseType, sub.order.domainLics) }}</span>
        </div>
        @if (sub.order.licenseType === "d") {
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_DOMAIN" | translate }}</span>
          <span>{{ sub.access.domain }}</span>
        </div>
        }
        @if (sub.order.licenseType === "m") {
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_USERS" | translate }}: </span>
          <span class="item-span">{{ sub.order.slotCount }}</span>
        </div>
        }
        @if (sub.order.licenseType === "d") {
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_EXTRA_USERS" | translate }}: </span>
          <span class="item-span">{{ sub.order.slotCount }}</span>
        </div>
        }
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_EXPIREDATE" | translate }}</span>
          <span>{{ sub.order.expireDate }}</span>
        </div>
        @if (sub.order.licenseType !== "s") {
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_LOCKED" | translate }}: </span>
          <span>{{ toLocalLocked(sub.order.locked) }}</span>
        </div>
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_LOCKED_ACCEPTED" | translate }}: </span>
          <span>{{ toLocalDateTime(sub.order.acceptedDate) }}</span>
        </div>
        }
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_ORDER_STATUS" | translate }}</span>
          <span>
            {{ getOrderStatus(sub) }}
            @if (sub.isSuspended || sub.isExpired) {
            <mat-icon>stroke_full</mat-icon>
            }
          </span>
        </div>
        <div class="item-special-container" [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_CREDITS_AI" | translate }}</span>
          @if (sub.order.aiCredits !== -1) {
          <span class="item-span"><mat-icon>toll</mat-icon>{{ sub.order.aiCredits }}</span>
          } @else {
          <span class="item-span" translate>ACCESSCONFIG_CREDITS_AI_WAIT</span>
          }
        </div>
        @if (sub.order.planId === "full") {
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_OCR_QUOTA" | translate }}</span>
          <span class="item-span">{{ sub.order.ocrMathScanQuota }}</span>
        </div>
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_OCR_POLICY" | translate }}</span>
          <span class="item-span">{{ "OCRSCAN_POLICY_" + sub.order.ocrMathScanPolicy | translate }}</span>
        </div>
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span" translate>OCRSCAN_LEFT</span>
          <span class="item-span">{{ sub.order.ocrMathScansLeft }}</span>
        </div>
        <div class="spacer"></div>
        }
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_ADMIN" | translate }}: </span>
          <span class="item-span">{{ sub.access.admin.name }} - {{ sub.access.admin.eMail }}</span>
        </div>
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_USER_NAME" | translate }}</span>
          <span class="item-span">{{ sub.order.fullName }} - {{ sub.order.userEmail }}</span>
        </div>
        <div [ngClass]="compressed() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "IC_SUB_TYPE_TITLE" | translate }}</span>
          <span class="item-span">
            {{ sub.order.redirectId ? ("IC_SUB_TYPE_RENEW" | translate) + " " + sub.order.redirectId :
            ("IC_SUB_TYPE_SUB" | translate) }}
          </span>
        </div>
      </div>

      <div style="flex-grow: 1"></div>
      <div class="spacer"></div>

      @if (sub.admin === true || isOperator()) {
      <div class="card-footer">
        @if (enabledDetail() && !compressed()) {
        <button mat-stroked-button (click)="openStatsClick.emit()"
          style="text-transform: uppercase"><mat-icon>query_stats</mat-icon>{{ "ACCESSCONFIG_OPENSTATS" | translate
          }}</button>
        }
        <button mat-flat-button (click)="configAccessClick.emit()"
          style="text-transform: uppercase"><mat-icon>edit</mat-icon>{{ "ACCESSCONFIG_DETAILS" | translate }}</button>
      </div>
      }
    </mat-card>

    <!-- ACQUISTO -->
    @if (sub.admin === true || isOperator()) {
    <mat-card style="flex-basis: 250px" class="card-container" appearance="outlined">
      <div class="title-container title-span" style="text-transform: uppercase">{{ "ACCESSCONFIG_BUY" | translate }}
      </div>
      <div class="card-content-vertical">
        @if (sub.order.origin !== "demo" && !sub.order.subscriptionId.startsWith("demo-")) {
        <button mat-flat-button class="action" (click)="renewClick.emit()">
          {{ "ACCESSCONFIG_RENEW_SUBSCRIPTION" | translate }}
        </button>
        }
        @if (sub.order.licenseType === "s" && !sub.order.subscriptionId.startsWith("demo-")) {
        <button mat-flat-button class="action" [disabled]="sub.isExpired || sub.order.aiCredits === -1"
          (click)="buyCreditsClick.emit()">
          {{ "ACCESSCONFIG_BUY_AI_CREDITS" | translate }}
        </button>
        } @else if (sub.order.licenseType !== "d" && sub.order.licenseType !== "m") {
        <div>{{ "ACCESSCONFIG_BUY_SUBSCRIPTION_TITLE" | translate }}</div>
        <button mat-flat-button class="action" (click)="goToWebsiteClick('order-list', 'private')">
          {{ "ACCESSCONFIG_BUY_SUBSCRIPTION" | translate }}
        </button>
        <div>{{ "ACCESSCONFIG_DISCOVER_TITLE" | translate }}</div>
        <button mat-flat-button class="action" (click)="goToWebsiteClick('order-list', 'school')">
          {{ "ACCESSCONFIG_DISCOVER" | translate }}
        </button>
        }
      </div>
      <div style="flex-grow: 1"></div>
      @if (historyExists(sub.order)) {
      <button mat-stroked-button style="text-transform: uppercase"
        (click)="showHistory(sub.order)"><mat-icon>history</mat-icon>{{ "ACCESSCONFIG_HISTORY" | translate }}</button>
      }
    </mat-card>
    }

    <!-- OPERATORI - dettaglio -->
    @if (isOperator() && !sub.showOrder) {
    <mat-card style="flex: 1" class="card-container" appearance="outlined">
      <span style="text-transform: uppercase" class="title-container title-span">{{ "ACCESSCONFIG_OPERATORS" | translate
        }}</span>
      <div
        style="display: flex; flex-direction: row; gap: 10px; justify-content: space-between; align-items: flex-start; flex-wrap: wrap">
        @if (canEditOrder()) {
        <button style="flex-shrink: 0" mat-flat-button [disabled]="!enabledDetail() || sub.order.aiCredits === -1"
          (click)="showUpdateOrder(sub)">
          {{ "ACCESSCONFIG_MODIFY-ORDER" | translate }}
        </button>
        }
        @if ((canSendMail() || canSendAdminMail()) && !isOrderExpired(sub)) {
        <button mat-button [matMenuTriggerFor]="mailMenu" style="align-self: flex-start; flex-shrink: 0">
          <mat-icon>email</mat-icon>
          {{ "ACCESSCONFIG_RESEND_EMAIL" | translate }}
        </button>
        }
      </div>
      <div class="spacer"></div>
      <div class="card-content">
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_ORIGIN" | translate }}</span>
          <span class="item-span">{{ getOriginType(sub.order.origin) }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_ORDERID" | translate }}</span>
          <span class="item-span">{{ sub.order.subscriptionId }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_REFORDERID" | translate }}</span>
          <span class="item-span">{{ getRefOrderId(sub.order.backofficeOrderId, sub.order.lastAction) }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_MECHCODE" | translate }}</span>
          <span>{{ sub.order.mechCode }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "START_DATE" | translate }}</span>
          <span>{{ sub.order.startDate }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_CREATIONDATE" | translate }}</span>
          <span>{{ toLocalDateTime(sub.order.creationDate) }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_CREATEDBY" | translate }}</span>
          <span>{{ sub.order.createdBy }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_LASTMODIFICATIONDATE" | translate }}</span>
          <span>{{ toLocalDateTime(sub.order.lastModificationDate) }}</span>
        </div>
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "ACCESSCONFIG_LASTMODIFICATIONBY" | translate }}</span>
          <span>{{ sub.order.lastModificationBy }}</span>
        </div>
        @if (canEditOrder()) {
        <div class="operator-param" [ngClass]="medium() ? 'param-minimun' : 'param'">
          <span class="subtitle-span">{{ "SUBSCRIPTION_NOTES" | translate }}</span>
          <span>{{ sub.order.notes }}</span>
        </div>
        }
      </div>
      @if (canDeleteSubscription()) {
      <div style="flex-grow: 1"></div>
      <div class="card-footer">
        <button mat-flat-button (click)="deleteClick.emit()">
          {{ "ACCESSCONFIG_DELETE_SUBSCRIPTION" | translate }}
        </button>
      </div>
      }
    </mat-card>
    }

    <!-- OPERATORI - modifica ordine -->
    @if (isOperator() && sub.showOrder) {
    <mat-card appearance="outlined" class="card-container" style="flex: 1">
      <span style="text-transform: uppercase" class="title-container title-span">{{ "ACCESSCONFIG_UPDATE_ORDER" |
        translate }}</span>
      <div class="card-content-vertical">
        <form [formGroup]="editOrderForm" novalidate (ngSubmit)="updateOrder(sub)">
          <app-order-config #orderForm [orderForm]="editOrderForm" [licenseType]="sub.order.licenseType"
            [userType]="sub.order.userType" [mechCode]="sub.order.mechCode" [planId]="sub.order.planId"
            [fullName]="sub.order.fullName" [userEmail]="sub.order.userEmail" [startDate]="sub.order.dbStartDate"
            [expireDate]="sub.order.dbExpireDate" [origin]="sub.order.origin" [suspended]="sub.order.suspended"
            [notes]="sub.order.notes" [slotCount]="sub.order.slotCount" [showSlot]="sub.order.licenseType !== 's'"
            [showDomainLics]="sub.order.licenseType === 'd'" [domainLics]="sub.order.domainLics"
            [minSlot]="sub.access.allocatedSlots" [ocrMathScanQuota]="sub.order.ocrMathScanQuota"
            [ocrMathScanPolicy]="sub.order.ocrMathScanPolicy" [aiCredits]="sub.order.aiCredits"> </app-order-config>
          <div class="update-button-panel">
            <button [disabled]="!isEnableUpdateOrder()" mat-flat-button type="submit">
              {{ "ACCESSCONFIG_SAVE" | translate }}
            </button>
            <button mat-button type="button" (click)="cancelOrderUpdate(sub)">
              {{ "ACCESSCONFIG_CANCEL" | translate }}
            </button>
          </div>
        </form>
      </div>
    </mat-card>
    }
  </div>
</mat-expansion-panel>

<mat-menu #mailMenu="matMenu">
  <ng-template matMenuContent>
    @if (canSendMail()) {
    <button mat-menu-item (click)="resendEmail(MailType.ACTIVATION, false)">
      {{ "ACCESSCONFIG_SENDEMAIL_ACTIVATION" | translate }}
    </button>
    @if (subscription().order.licenseType === "m" || subscription().order.licenseType === "d") {
    <button mat-menu-item (click)="resendEmail(MailType.RENEW, false)">
      {{ "ACCESSCONFIG_SENDEMAIL_RENEW" | translate }}
    </button>
    }
    }
    @if (canSendAdminMail()) {
    <button mat-menu-item (click)="resendEmail(MailType.ACTIVATION, true)">
      {{ "ACCESSCONFIG_SENDADMINEMAIL_ACTIVATION" | translate }}
    </button>
    @if (subscription().order.licenseType === "m" || subscription().order.licenseType === "d") {
    <button mat-menu-item (click)="resendEmail(MailType.RENEW, true)">
      {{ "ACCESSCONFIG_SENDADMINEMAIL_RENEW" | translate }}
    </button>
    }
    }
  </ng-template>
</mat-menu>